// eslint-disable-next-line import/prefer-default-export
export const isTaskTypeVerification = (taskType: string) => {
	return taskType.includes('Verification')
}
